import type { Listing } from '@thevillages/schemas';

import { CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';

import { FilteringService } from '../../../services/filtering';
import { StateService } from '../../../services/state/state';
import { SaveListing } from '../../save-listing/save-listing';
import { PlaceholderImage } from './placeholder-image';

@Component({
  imports: [NgOptimizedImage, SaveListing, CurrencyPipe],
  providers: [PlaceholderImage],
  selector: 'app-homesite-listing-card',
  styleUrl: './homesite.css',
  templateUrl: './homesite.html',
})
export class HomesiteListingCard {
  protected readonly filteringService = inject(FilteringService);
  protected readonly stateService = inject(StateService);

  public readonly initialRender = input(false);
  public readonly listing = input.required<Listing>();
  public readonly saveClicked = output();

  protected readonly willAccommodateColors = computed(() => {
    const _blank = 'gray';

    if (!this.listing().willAccommodate) {
      return _blank;
    }
    if (!this.filteringService.availableSeries.hasValue()) {
      return _blank;
    }

    const _output = [];

    for (const _seriesId of this.listing().willAccommodate?.series ?? []) {
      const _series = this.filteringService.availableSeries.value().find((s) => s.id === _seriesId);

      _output.push(_series?.color ?? _blank);
    }

    return _output;
  });
}
